import React from "react";
import PropTypes from 'prop-types';
import Card from "@material-ui/core/Card/Card";
import Divider from "@material-ui/core/Divider";
import {Draggable, Droppable} from "react-beautiful-dnd";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";

const useStyles = makeStyles(() => ({
    columnsWrapper: {
        width: 200,
        minHeight: 350,
        margin: 5,
        padding: 5
    },
    columnsHeader: {
        display: 'flex',
        alignItems: 'center'
    },
    cardContentWrapper: {
        height: 320,
        overflowY: 'auto'
    }
}));

const DestinationColumns = ({destination, columnNames}) => {
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);
    return (
        <Card className={classes.columnsWrapper}>
            <div className={classes.columnsHeader}>
                {columnNames}
            </div>
            <Divider/>
            <Droppable droppableId={'destinationItems'}>
                {(provided) => (
                    <List
                        dense={true}
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className={classes.cardContentWrapper}
                    >
                        {destination.map((field, index) => {
                            const multiLanguageLabel = multiLanguageValue(field.label, userLanguage)
                            return (
                                <Draggable
                                    draggableId={`destination__${field.name}__${index}`}
                                    index={index}
                                    key={field.name}
                                >
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <ListItem>
                                                <ListItemText primary={multiLanguageLabel}/>
                                            </ListItem>
                                            <Divider/>
                                        </div>
                                    )}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </List>
                )}
            </Droppable>
        </Card>
    )
};
export default DestinationColumns;

DestinationColumns.propTypes = {
    destination: PropTypes.array
};